export default "Grammar\n\n<router-outlet></router-outlet>\n"